import { Skeleton, Stack, Typography } from '@mui/material';
import { Rollup, RollupStatus } from 'shared/types/protoc-gen/raas-rollup';

import { rollupStatusLabelMap } from '../helpers/labels';

export interface IRollupStatusChip {
  rollup?: Rollup;
  loading?: boolean;
  hideDate?: boolean;
}

export const RollupStatusChip = ({ hideDate = true, loading, rollup }: IRollupStatusChip) => {
  return (
    <Stack alignItems="center" direction="row" display="flex" justifyContent="end" spacing="16px">
      {!hideDate && rollup?.startupAt && (
        <Typography variant="caption">
          {[
            'Since',
            new Date(rollup.startupAt).toLocaleDateString('en-US', {
              month: '2-digit',
              day: '2-digit',
            }),
          ].join(' ')}
        </Typography>
      )}
      {loading ? (
        <Skeleton height="24px" variant="rectangular" width="68px" />
      ) : (
        rollupStatusLabelMap[rollup?.status ?? RollupStatus.ROLLUPSTATUS_UNSPECIFIED]
      )}
    </Stack>
  );
};
